export default "__VITE_ASSET__CO2ASe5D__"